/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowWeekendGetawayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowWeekendGetaway,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Escape for the Weekend!",
    "Weekend Adventure Awaits!",
    "Let’s Get Away!",
  ],
  title: "Weekend Getaway",
  description: "Organize a weekend trip to relax and explore.",
  longDescription:
    "Plan the perfect weekend getaway. Choose your dates, select an exciting destination, and split the expenses effortlessly!",
  emoji: "🏖",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Weekend Getaway",
          emoji: "🏖",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go?",
          emoji: "📅",
          completeAction: {
            question: "Decide on locations?",
            description: "Let’s pick a fun destination for our getaway!",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "Where should we go?",
                emoji: "🌍",
                completeAction: {
                  question: "Split expenses?",
                  description: "Shall we split the costs for this trip?",
                  addModules: [
                    {
                      type: ModuleType.Expense,
                      doneType: ModuleDoneType.None,
                      title: "How to split expenses?",
                      emoji: "💰",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Ready for Adventure!",
    outroDescription:
      "Your weekend getaway is planned! Pack your bags and enjoy the trip!",
  },
};
